module.exports = __webpack_public_path__ + "img/Weapon_190.e354d23f.png";